import React, { useState } from 'react';
import { Loader2, AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import PrivacyNoticeContent from '../components/PrivacyNoticeContent';

export default function PrivacyNoticeScreen() {
  const { acceptPrivacyNotice, requiredPrivacyVersion } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAccept = async () => {
    setLoading(true);
    setError(null);
    try {
      await acceptPrivacyNotice(requiredPrivacyVersion);
    } catch (err) {
      setError(err.message || 'Failed to record acceptance. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f8f9fc',
      display: 'flex',
      justifyContent: 'center',
      padding: '40px 20px',
    }}>
      <div style={{
        maxWidth: '680px',
        width: '100%',
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '32px',
        }}>
          <div style={{
            background: '#F5C400',
            border: '3px solid #111',
            borderRadius: '8px',
            display: 'inline-block',
            padding: '8px 24px',
            marginBottom: '12px',
          }}>
            <div style={{
              fontFamily: "'Oswald', sans-serif",
              fontSize: '28px',
              fontWeight: 700,
              color: '#111',
              letterSpacing: '6px',
            }}>VCIN</div>
          </div>
        </div>

        {/* Document */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '40px 36px',
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          fontFamily: "'Inter', sans-serif",
          color: '#1a1a2e',
          lineHeight: 1.7,
          fontSize: '14.5px',
        }}>
          <PrivacyNoticeContent requiredPrivacyVersion={requiredPrivacyVersion || '2026-05-13'} />

          <div style={{
            borderTop: '1px solid #e4e8f0',
            marginTop: '32px',
            paddingTop: '24px',
          }}>
            <p style={{ fontSize: '13.5px', color: '#4a5a7a', marginBottom: '20px' }}>
              By clicking "I accept" below, you confirm that you have read this notice and understand how VCIN processes your data.
            </p>

            {error && (
              <div style={{
                background: '#fff5f5',
                border: '1.5px solid #fecaca',
                borderLeft: '4px solid #dc2626',
                borderRadius: '10px',
                padding: '12px 14px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
              }}>
                <AlertCircle size={15} color="#dc2626" style={{ flexShrink: 0, marginTop: '1px' }} />
                <span style={{ fontSize: '13px', color: '#dc2626', lineHeight: 1.4 }}>{error}</span>
              </div>
            )}

            <button
              onClick={handleAccept}
              disabled={loading}
              style={{
                width: '100%',
                height: '50px',
                border: 'none',
                borderRadius: '10px',
                background: loading ? '#c8d0e0' : '#001a4d',
                color: loading ? '#8a9ab8' : 'white',
                fontFamily: "'Oswald', sans-serif",
                fontSize: '16px',
                fontWeight: 700,
                letterSpacing: '4px',
                textTransform: 'uppercase',
                cursor: loading ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                transition: 'all 0.15s',
              }}
            >
              {loading
                ? <><Loader2 size={18} style={{ animation: 'spin 1s linear infinite' }} /> Recording acceptance...</>
                : 'I Accept'
              }
            </button>
          </div>
        </div>

        <div style={{
          marginTop: '20px',
          fontSize: '11px',
          color: 'rgba(0,0,0,0.3)',
          textAlign: 'center',
          lineHeight: 1.6,
        }}>
          VCIN — Vehicle Crime Intelligence Network
        </div>
      </div>
    </div>
  );
}
